// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"2d39f3d6","76":"1ffae773","142":"6ba098dc","358":"8b460bea","438":"2dcb4373","476":"b0eab634","561":"7835fde6","728":"23a4c60a","946":"2735ea18"}[chunkId] + ".chunk.js";
};